const FIRST_LOGIN_SEEN_PREFIX = 'first_login_seen'
const POST_LOGIN_TARGET_MENU_KEY = 'post_login_target_menu_key'

function buildFirstLoginSeenKey({ cid, userName }) {
  const safeCid = cid || 'unknown-cid'
  const safeUserName = userName || 'unknown-user'
  return `${FIRST_LOGIN_SEEN_PREFIX}:${safeCid}:${safeUserName}`
}

function isFirstLoginUser(payload) {
  const storageKey = buildFirstLoginSeenKey(payload || {})
  return localStorage.getItem(storageKey) !== '1'
}

function markFirstLoginUserSeen(payload) {
  const storageKey = buildFirstLoginSeenKey(payload || {})
  localStorage.setItem(storageKey, '1')
}

function queuePostLoginMenu(menuKey) {
  if (!menuKey) {
    localStorage.removeItem(POST_LOGIN_TARGET_MENU_KEY)
    return
  }

  localStorage.setItem(POST_LOGIN_TARGET_MENU_KEY, menuKey)
}

function consumePostLoginMenu() {
  const menuKey = localStorage.getItem(POST_LOGIN_TARGET_MENU_KEY)
  localStorage.removeItem(POST_LOGIN_TARGET_MENU_KEY)
  return menuKey
}

export {
  isFirstLoginUser,
  markFirstLoginUserSeen,
  queuePostLoginMenu,
  consumePostLoginMenu
}
